import { useEffect } from 'react';

import Hotjar from '../helpers/hotjar';
import Wootric from '../helpers/wootric';
import { wootricToken } from '../utils/envs';
import { isInternalAccess } from '../utils/internal-access';

const useWootric = (hotjarTagsRecording, userInfo) => {
  const { createdAt, email, id, isAdmin, planType, userStatus: status } = userInfo;
  useEffect(() => {
    if (isInternalAccess(isAdmin) || status !== 'ready') return;

    Wootric.boot(wootricToken, {
      createdAt,
      email,
      id,
      planType,
      callback: () => Hotjar.tagsRecording(hotjarTagsRecording),
    });
  }, [isAdmin, createdAt, email, status, id, planType, hotjarTagsRecording]);
};

export default useWootric;
